import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import MaintenancePage from "./components/MaintenancePage";
import UploadStep from "./components/UploadStep";
import adobe from "./icons/Adobe.png";
import anaretouchme from "./icons/anaretouchme.png";
import anaretouchme2 from "./icons/anaretouchme2.png";
import tgIcon from "./icons/tg.png";
import waIcon from "./icons/wa.png";
import igIcon from "./icons/IG.png";
import backIcon from './icons/back_icn.png';
import bgMobile from "./bg/bg-mobile-opt.mp4";
import bgLandscape from "./bg/bg-landscape-opt.mp4";
import axios from 'axios';

const TermsConditionsContent = () => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);

    useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;

      const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval.current);
	    scrollInterval.current = null;
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval.current);
	scrollInterval.current = null;
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      };

      content.addEventListener('wheel', stopAutoScroll, { passive: true });
      content.addEventListener('touchstart', stopAutoScroll, { passive: true });

      return () => {
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
        clearInterval(scrollInterval.current);
      };
    }
  }, []);

return (
  <div className="legal-content-container">
    <div className="legal-content" ref={contentRef}>
      <h1>Terms and Conditions</h1>
      <p><strong>Effective date:</strong> April 30, 2026</p>

      <h2>Introduction</h2>
      <p>
        Welcome to <strong>Ana Retouch Me</strong>, a service operated by
        Quality Performance Core Ltd ("Quality Performance Core", "qpcore", "we", "us", or "our").
        By accessing or using this micro-site you agree to these Terms and
        Conditions (“Terms”). Please read them carefully.
      </p>

      <h2>Scope of Service</h2>
      <p>
        This page lets you submit one image for a complimentary
        retouch / color-grade test. The file is uploaded via the form and
        delivered to our secure storage; you will receive a finished JPEG
        without additional revisions.
      </p>

      <h2>Use of the Site</h2>
      <p>
        You may use the site only for its intended purpose — requesting a sample
        retouch. Any other use (e.g., bulk uploads, commercial redistribution)
        is prohibited unless we give written permission.
      </p>

      <h2>User Responsibilities</h2>
      <p><strong>Legal compliance:</strong> you agree to follow all applicable
        laws and not submit unlawful or copyrighted material without
        permission.</p>
      <p><strong>File suitability:</strong> please upload high-quality images
        (JPEG / PNG, up to 256 MB). Low-resolution or corrupted files may be
        rejected.</p>

      <h2>Intellectual Property</h2>
      <p>
        All retouched results remain your property; we keep a copy only for
        portfolio or internal training if you grant explicit permission.
        The site design, workflow, and text are owned by Quality Performance Core Ltd
        and may not be reproduced without consent.
      </p>

      <h2>Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless Quality Performance Core Ltd from
        any claims arising out of content you provide or your breach of these
        Terms.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        Service is provided “as is”. We are not liable for indirect or
        consequential damages, including data loss, arising from use of the
        site or the retouch result.
      </p>

      <h2>Governing Law</h2>
      <p>
        These Terms are governed by the laws of United Kingdom. Exclusive venue for any
        dispute is the courts of London unless mandatory law states otherwise.
      </p>

      <h2>Changes</h2>
      <p>
        We may modify these Terms at any time, updates take effect upon posting.
      </p>

      <h2>Contact</h2>
      <p>
        Questions? Email <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>
    </div>
  </div>
);

};

const PrivacyPolicyContent = () => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);

    useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;

      const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval.current);
	    scrollInterval.current = null;
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval.current);
	scrollInterval.current = null;
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      };

      content.addEventListener('wheel', stopAutoScroll, { passive: true });
      content.addEventListener('touchstart', stopAutoScroll, { passive: true });

      return () => {
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
        clearInterval(scrollInterval.current);
      };
    }
  }, []);

return (
  <div className="legal-content-container">
    <div className="legal-content" ref={contentRef}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective date:</strong> April 30, 2026</p>

      <h2>Introduction</h2>
      <p>
        At <strong>Ana Retouch Me</strong> (operated by
        Quality Performance Core Ltd) we respect your privacy.
        This Policy explains how we collect, use, and protect data on this Ana Retouch Me page.
      </p>

      <h2>Data We Collect</h2>
      <p>
        We collect your <strong>full name and e-mail address</strong> solely for
        internal processing. Technical data such as browser type or device may
        be collected by embedded third-party services (e.g., Adobe, Telegram, Instagram).
      </p>

      <h2>Legal Basis</h2>
      <p>
        We process personal data based on your <em>consent</em> (Art. 6(1)(a)
        GDPR) — granted when you click “Next.” You may withdraw consent at any
        time, after which we cease processing unless another legal basis applies.
      </p>

      <h2>Your Rights</h2>
      <p>
        You have the right to access, correct, delete, restrict, or transfer your
        data, and to lodge a complaint with the United Kingdom DPA. To exercise any
        right, email <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>

      <h2>Analytics & Tracking</h2>
      <p>
        We use <strong>Facebook Conversion API</strong> and <strong>Telegram Bot API</strong> strictly server-side to log button
        clicks. No client-side tracking scripts or cookies are embedded in the
        React app. Transmitted fields are limited to name, e-mail, IP address,
        and device type.
      </p>

      <h2>Retention</h2>
      <p>
        Personal data are retained no longer than 12 months after your last
        interaction or until consent is withdrawn, whichever occurs first.
      </p>

      <h2>International Transfers</h2>
      <p>
        Data may be transferred to Meta Platforms (US) and Telegram FZ-LLC (UAE)
        under Standard Contractual Clauses and Telegram’s public offer.
      </p>

      <h2>Cookies</h2>
      <p>
        This page does <strong>not</strong> use cookies. Should that change,
        we will update this Policy and request your consent.
      </p>

      <h2>Data Security</h2>
      <p>
        We employ HTTPS, database encryption, access controls, and backups.
      </p>

      <h2>Children’s Privacy</h2>
      <p>
        The site is not directed to anyone under 16. We do not knowingly collect
        personal data from children.
      </p>

      <h2>Policy Updates</h2>
      <p>
        We may revise this Policy periodically. Updates will appear here with a
        new effective date.
      </p>

      <h2>Contact</h2>
      <p>
        For questions or comments, e-mail <a href="mailto:contact@qpcore.com">contact@qpcore.com</a>.
      </p>
    </div>
  </div>
);

}

function ContactForm({ onSubmit }) {
  const [fullName, setFullName] = useState("");
  const [email, setEmail]   = useState("");
  const [err, setErr] = useState("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValid    = fullName.trim() && emailRegex.test(email);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isValid) {
      setErr("Please fill in both fields correctly");
      return;
    }
    setErr("");
    onSubmit({ fullName: fullName.trim(), email: email.trim() });
  };

  useEffect(() => {
    if (err) {
      const timer = setTimeout(() => setErr(""), 2000);
      return () => clearTimeout(timer);
    }
  }, [err]);

  return (

    <div className="contact-form-wrapper">
      <p className="consent-info">
        By clicking "Next", you agree to the processing of personal data.
        In the next step, you upload a photo and description.
      </p>

    <form className="contact-form" onSubmit={handleSubmit} noValidate>
      <label>
        Person data
        <input
          type="text"
	  value={fullName}
	  placeholder="Full Name"
          onChange={(e) =>
	    setFullName(e.target.value.replace(/\s+/g, " ").trimStart())
	  }
          required
        />
      </label>

      <label>
          E-mail
          <input
            type="email"
            value={email}
            placeholder="name@example.com"
            pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

      <small className="consent-inline">
          By clicking "Next", you consent to the processing of data.
        </small>

      <button type="submit" className="button">
        <div className="button-content">
          <span className="button-text">Next</span>
        </div>
      </button>
    </form>

   {err && <div className="form-error-overlay">{err}</div>}
    </div>
  );
}

function App() {
  const [currentStep, setCurrentStep] = useState(0);
  const [leadData, setLeadData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const isMaintenanceMode = false;
  const [isIpAllowed, setIsIpAllowed] = useState(false);

  useEffect(() => {
    const checkIpRoute = async () => {
      try {
        const response = await axios.get("/api/ip/check-ip");
        if (response.data && response.data.allowed === true) {
          setIsIpAllowed(true);
        } else {
          setIsIpAllowed(false);
        }
      } catch (error) {
        console.error("Error checking IP on server:", error);
        setIsIpAllowed(false);
      }
    };

    checkIpRoute();
  }, []);

  const isMaintenanceActive = isMaintenanceMode && !isIpAllowed;
  const shouldShowBackIcon = currentStep !== 0 || showForm; 

  const sendEvent = async (eventName, payload = {}) => {
    try {
      const response = await fetch('/api/track-event', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          eventName, ...payload
        })
      });

      const data = await response.json();
      if (data.success) {
      } else {
        console.error(`Помилка при відправці події "${eventName}":`, data.error);
      }
    } catch (error) {
      console.error(`Помилка при відправці події "${eventName}":`, error);
    }
  };

  const handleLinkClick = (event, eventName, url = null) => {
  event.preventDefault();

  const payload = JSON.stringify({ eventName });

  const send = () => {
    if (navigator.sendBeacon) {
      try {
        const blob = new Blob([payload], { type: 'application/json' });
        navigator.sendBeacon('/api/track-event', blob);
      } catch {}
    } else {
      fetch('/api/track-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  };

  if (url) {
    send();
    window.location.assign(url);
  } else {
    send();
  }
};
  const steps = [
  {
    id: "welcome",
    content: (
      <>
        {!showForm && !leadData && (

            <div className="button-container">
	   <a
	     href="#deal"
	     className="button"
	     onClick={(e) => {
	       handleLinkClick(e, "Deal Request Button");
	       setShowForm(true);
	     }}
  	    >
	      <div className="button-content">
	        <div className="button-icon-container">
	         <img src={anaretouchme2} alt="Deal" className="button-icon" />
	        </div>
	        <span className="button-text">Request a Deal</span>
 	       </div>
              </a>

              <a
                href="https://anaretouchme.com/go/adobe"
                className="button"
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Adobe Portfolio",
                    "https://anaretouchme.com/go/adobe"
                  )
                }
              >
                <div className="button-content">
                  <div className="button-icon-container">
                    <img src={adobe} alt="Adobe" className="button-icon" />
                  </div>
                  <span className="button-text">Adobe Portfolio</span>
                </div>
              </a>

              <a
                href="https://anaretouchme.com/go/whatsapp"
                className="button"
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "WhatsApp Chat",
                    "https://anaretouchme.com/go/whatsapp"
                  )
                }
              >
                <div className="button-content">
                  <div className="button-icon-container">
                    <img src={waIcon} alt="WhatsApp" className="button-icon" />
                  </div>
                  <span className="button-text">WhatsApp Chat</span>
                </div>
              </a>

              <a
                href="https://anaretouchme.com/go/telegram"
                className="button"
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Telegram Chat",
                    "https://anaretouchme.com/go/telegram"
                  )
                }
              >
                <div className="button-content">
                  <div className="button-icon-container">
                    <img src={tgIcon} alt="Telegram" className="button-icon" />
                  </div>
                  <span className="button-text">Telegram Chat</span>
                </div>
              </a>

              <a
                href="https://anaretouchme.com/go/instagram"
                className="button"
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Instagram Profile",
                    "https://anaretouchme.com/go/instagram"
                  )
                }
              >
                <div className="button-content">
                  <div className="button-icon-container">
                    <img src={igIcon} alt="Instagram" className="button-icon" />
                  </div>
                  <span className="button-text">Visit Instagram</span>
                </div>
              </a>
            </div>
        )}

        {showForm && !leadData && (
	  <ContactForm
	    onSubmit={(data) => {
	      const [firstName = "", lastName = ""] = data.fullName.split(" ");
	      setLeadData({ firstName, lastName, email: data.email });

	      sendEvent("Lead", {
		userData: { email: data.email, firstName, lastName },
	      });
	    }}
	  />
	)}

       {leadData && (
	 <>
	  <h1 className="slide-down">Pro Retouch</h1>
        <h2 className="slide-down">One image · One Free Revision</h2>
        <p className="slide-up">
          Upload <b>one portrait</b> along with <b>references</b> and your <b>edit notes</b>.<br />
          I’ll review, reply with <b>pricing</b> and <b>schedule</b>, then deliver your <b>retouched image</b> on time.
        </p>

	  <UploadStep
	    leadData={leadData}
	    sendEvent={sendEvent}
	    resetFlow={() => {
	      setLeadData(null);
	      setShowForm(false);
	      setCurrentStep(0);
	    }}
	  />
	 </>
	)}
      </>
    ),
  },
  {
    id: "privacy-policy",
    title: "",
    subtitle: "",
    description: "",
    content: <PrivacyPolicyContent />,
  },
  {
    id: "terms-conditions",
    title: "",
    subtitle: "",
    description: "",
    content: <TermsConditionsContent />,
  },
];

const handleFooterLinkClick = (stepIndex) => setCurrentStep(stepIndex);

const handleBackClick = () => {
  if (currentStep !== 0) {      
      setCurrentStep(0);
    } else if (leadData) {    
      setLeadData(null);
    } else if (showForm) {  
      setShowForm(false);
    }
};

const renderSteps = () => {
  const step = steps[currentStep];

  return (
    <div key={currentStep} className="content visible" id={`step-${currentStep}`}>
      {currentStep === 0 && !showForm && !leadData && (
        <div className="coin-container">
          <img src={anaretouchme} alt="qp Core" className="coin" />
        </div>
      )}
      {!(currentStep === 0 && (showForm || leadData)) && (
      <>
      {step.title && <h1 className="slide-down">{step.title}</h1>}
      {step.subtitle && <h2 className="slide-down">{step.subtitle}</h2>}
      {step.description && <p className="slide-up">{step.description}</p>}
      </>
      )}
      {step.content}
    </div>
  );
};

  return isMaintenanceActive ? (
    <MaintenancePage />
  ) : (

    <>

    <video
    className="bg-video mobile-bg"
    src={bgMobile}
    autoPlay
    loop
    muted
    playsInline
  />

  <video
    className="bg-video landscape-bg"
    src={bgLandscape}
    autoPlay
    loop
    muted
    playsInline
  />	

    <div className="App">
      <header className="App-header">

	{currentStep === 0 && !showForm && !leadData && (
         <div className="marquee">
	    <span><em>Test my retouch and color grading on a portrait of your choice.</em></span>
	    <span aria-hidden="true"><em>Pay once, see results within our agreed turnaround.</em></span>
	  </div>
	)}

        {renderSteps()}
        {shouldShowBackIcon && (
          <img
            src={backIcon}
            alt="Back"
            className="back-icon visible"
            onClick={handleBackClick}
          />
        )}
      </header>
      <footer className="footer">
        <div className="footer-content slide-up">
          <button
            className="footer-link"
            onClick={() => handleFooterLinkClick(1)}
          >
            Privacy
          </button>
          <span className="footer-divider">|</span>
          <button
            className="footer-link"
            onClick={() => handleFooterLinkClick(2)}
          >
            Terms
          </button>
          <span className="footer-divider">|</span>
          <span className="footer-copy">© qpCore 2026</span>
        </div>
      </footer>
    </div>
   </>
  );
}

export default App;

